// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"c9e26608","385":"b83ca5d1"}[chunkId] + ".chunk.js";
};